import { BigNumber } from "bignumber.js";

import { nesaTestnet } from "app/config/chains";

export const fromUnesToNes = (value: string) => {
  return new BigNumber(value).div(new BigNumber(10).pow(nesaTestnet.feeCurrencies[0].coinDecimals));
};
